import { ICS2MessageTypes } from 'store/declarations/enums/common/declaration-types';
import { FormType } from 'views/declarations/common/DeclarationContext';
import { NonAmendableFieldResolver } from 'views/declarations/utils/nonAmendableFields';

const nonAmendableFieldPaths: Record<ICS2MessageTypes, Partial<Record<FormType, string[]>>> = {
    [ICS2MessageTypes.F11]: {
        master: [
            'specificCircumstanceIndicator',
            'representative.identificationNumber',
            'activeBorderTransportMeans.identificationNumber',
            'activeBorderTransportMeans.modeOfTransport',
            'declarant.identificationNumber',
            'customsOfficeOfFirstEntry.referenceNumber',
            'consignmentMasterLevel.carrier.identificationNumber',
            'consignmentMasterLevel.transportDocumentMasterLevel.documentNumber',
        ],
        'house-consignment': ['transportDocumentHouseLevel.documentNumber'],
    },
    [ICS2MessageTypes.F50]: {
        master: [
            'specificCircumstanceIndicator',
            'representative.identificationNumber',
            'activeBorderTransportMeans.modeOfTransport',
            'declarant.identificationNumber',
            'customsOfficeOfFirstEntry.referenceNumber',
            'consignmentMasterLevel.carrier.identificationNumber',
            'consignmentMasterLevel.transportDocumentMasterLevel.documentNumber',
        ],
        'house-consignment': ['transportDocumentHouseLevel.documentNumber'],
    },
};

export const ics2NonAmendableFields: NonAmendableFieldResolver = {
    owns: (declaration) => Boolean(declaration.ics2ENSDeclaration),
    isNonAmendable: (declaration, form, path) => {
        const messageType = declaration.ics2ENSDeclaration?.messageType;
        const paths = messageType && form ? nonAmendableFieldPaths[messageType]?.[form] : undefined;

        return Boolean(paths?.some((field) => path === field || path.startsWith(`${field}.`)));
    },
};
